import { html } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';

export const emTemplate = (
  node: HTMLElement,
) => html`<one-text strong>${unsafeHTML(node.innerHTML)}</one-text>`;
